// @flow
import SocialBlock from './SocialBlock'

export default SocialBlock
